import React from 'react';
import UniversalAddItemForm from '../shared/UniversalAddItemForm';

const BonlivAddItemForm = ({ refBonliv, onSuccess, bonlivStatus }) => {
  // Custom quantity handler for bonliv special fields
  const handleQuantityChange = (newData, setItemData, calculateTotals) => {
    const value = newData.QTE || 0;
    const updatedItemData = {
      ...newData,
      qte_prepare: -1,
      qte_controle: -1,
      qte_liv: -1
    };

    switch (bonlivStatus) {
      case 'EN_PREPARATION':
        updatedItemData.qte_prepare = value;
        break;
      case 'PREPARE':
        updatedItemData.qte_controle = value;
        break;
      case 'VALIDE':
      case 'TRANSFERE':
        updatedItemData.qte_liv = value;
        break;
      default:
        updatedItemData.qte_prepare = value;
        updatedItemData.qte_controle = value;
        updatedItemData.qte_liv = value;
    }

    const totals = calculateTotals(updatedItemData);
    setItemData({ ...updatedItemData, ...totals });
  };

  return (
    <UniversalAddItemForm
      refField="REF_BL"
      refValue={refBonliv}
      onSuccess={onSuccess}
      priceType="selling"
      enableBatch={true}
      useArticleList={false}
      extraFields={{ qte_prepare: -1, qte_controle: -1, qte_liv: -1 }}
      onQuantityChange={handleQuantityChange}
      submitButtonText="Add all to Bonliv"
    />
  );
};

export default BonlivAddItemForm;
